import React, { useRef, useImperativeHandle } from 'react';
import SliderItem from './SliderItem';
import SliderContext from './SliderContext';
import useSlider from '../../../hooks/useSlide';

function Jumbotron (props, ref) {
  const refJumbotron = useRef(null);

  const {
    moveSlide,
    sliderIndex,
    sliderPages,
    bigPaginationIndicator,
    bigPaginationAutoButton,
    totalInViewport
  } = useSlider(refJumbotron, props.data.length, props.data, props.type, 3500, props.onChangeCurrentIndex);

  if (ref != null) {
    useImperativeHandle(ref, () => ({
      mainOnMouseOver: (e) => {
        moveSlide('onmouse_pause');
      },
      mainOnMouseOut: (e) => {
        moveSlide('play');
      }
      // mainOnMouseOut
    }));
  }

  return (
    <SliderContext.Provider value={[]}>
      <div role='region' aria-label='대표 콘텐츠 소개 슬라이드' className='module_visual_spot_w'>
        {props.data.length > 0 && (
          <button className='mvs_btn_prev_w' aria-label='이전 콘텐츠 보기' onClick={() => moveSlide('left')} onMouseOver={(e) => moveSlide('onmouse_pause')} onMouseOut={(e) => moveSlide('play')}>
            <span className='mvsb_prev'>
              <svg xmlns='http://www.w3.org/2000/svg' width='26.414' height='50.828' viewBox='0 0 26.414 50.828'>
                <path className='mvsb_arrow' d='M-11095.5-16189.5l-24,24,24,24' transform='translate(11120.501 16190.914)' />
              </svg>
              <i className='hide'>이전 콘텐츠 보기</i>
            </span>
          </button>)}

        <ul className='mvs_list_w' ref={refJumbotron}>
          {props.data.map((item, index) => {
            const sliderIndexViewStart = (sliderIndex * totalInViewport);
            const sliderIndexViewEnd = sliderIndexViewStart + totalInViewport;
            const isBetween = index >= sliderIndexViewStart && index < sliderIndexViewEnd;
            return (
              <SliderItem
                key={index}
                view={isBetween}
                slide_key={item.id || item.order_no || item.ord_no}
                {...item}
                index={index}
                currentIndex={sliderIndex}
                type='modulebox'
                moveSlide={moveSlide}
                imageQuality={100}
              />
            );
          })}
        </ul>

        {props.data.length > 0 && (
          <button className='mvs_btn_next_w' aria-label='다음 콘텐츠 보기' onClick={() => moveSlide('right')} onMouseOver={(e) => moveSlide('onmouse_pause')} onMouseOut={(e) => moveSlide('play')}>
            <span className='mvsb_next'>
              <svg xmlns='http://www.w3.org/2000/svg' width='26.414' height='50.828' viewBox='0 0 26.414 50.828'>
                <path className='mvsb_arrow' d='M-11119.5-16189.5l24,24-24,24' transform='translate(11120.915 16190.914)' />
              </svg>
              <i className='hide'>다음 콘텐츠 보기</i>
            </span>
          </button>)}

        <div className='mvs_paging_w'>
          <div className='mvs_paging_inner'>
            <ul className='mvsp_list_w'>
              {sliderPages > 0 ? (bigPaginationIndicator(sliderPages)) : ''}
            </ul>
            <>
              {sliderPages > 0 ? (bigPaginationAutoButton()) : ''}
            </>
          </div>
        </div>
      </div>
    </SliderContext.Provider>
  );
}
const forwardedRefInput = React.forwardRef(Jumbotron);
export default forwardedRefInput;
